import { usergetStorageSync, usersetStorageSync } from '@/common/browser-storage'
const CONTROL_BACKGROUND_SOFTENING_STORAGE_KEY = 'controlBackgroundSofteningLevel'
const DEFAULT_CONTROL_BACKGROUND_SOFTENING_LEVEL = 'standard'

const CONTROL_BACKGROUND_SOFTENING_OPTIONS = [
  { key: 'none', text: '无虚化', alpha: 0 },
  { key: 'low', text: '低虚化', alpha: 0.3 },
  { key: 'standard', text: '标准虚化（默认）', shortText: '标准虚化', alpha: 0.46 },
  { key: 'high', text: '高虚化', alpha: 0.6 }
]

const normalizeControlBackgroundSofteningLevel = level => {
  return CONTROL_BACKGROUND_SOFTENING_OPTIONS.some(option => option.key === level)
    ? level
    : DEFAULT_CONTROL_BACKGROUND_SOFTENING_LEVEL
}

const getControlBackgroundSofteningOption = level => {
  const normalizedLevel = normalizeControlBackgroundSofteningLevel(level)
  return (
    CONTROL_BACKGROUND_SOFTENING_OPTIONS.find(option => option.key === normalizedLevel) ||
    CONTROL_BACKGROUND_SOFTENING_OPTIONS[2]
  )
}

const getControlBackgroundSoftenerColor = level => {
  const option = getControlBackgroundSofteningOption(level)
  return 'rgba(9, 18, 27, ' + option.alpha + ')'
}

const getStoredControlBackgroundSofteningLevel = () => {
  try {
    return normalizeControlBackgroundSofteningLevel(
      usergetStorageSync(CONTROL_BACKGROUND_SOFTENING_STORAGE_KEY)
    )
  } catch (error) {
    console.warn('读取背景虚化设置失败', error)
    return DEFAULT_CONTROL_BACKGROUND_SOFTENING_LEVEL
  }
}

const saveControlBackgroundSofteningLevel = level => {
  const normalizedLevel = normalizeControlBackgroundSofteningLevel(level)
  try {
    usersetStorageSync(CONTROL_BACKGROUND_SOFTENING_STORAGE_KEY, normalizedLevel)
  } catch (error) {
    console.warn('保存背景虚化设置失败', error)
  }
  return normalizedLevel
}

export {
  CONTROL_BACKGROUND_SOFTENING_OPTIONS,
  DEFAULT_CONTROL_BACKGROUND_SOFTENING_LEVEL,
  getControlBackgroundSofteningOption,
  getControlBackgroundSoftenerColor,
  getStoredControlBackgroundSofteningLevel,
  normalizeControlBackgroundSofteningLevel,
  saveControlBackgroundSofteningLevel
}
